import {Yup} from 'utils/validators';

/**
 * @constant ERROR_MESSAGE_INVENTORY - Error messages for inventory validation
 * @type {{number: string, emptyInventory: string, negativeInventory: string, cancelOrConfirm: string}}
 */
export const ERROR_MESSAGE_INVENTORY = {
    number: 'Inventory must be a whole number.',
    emptyInventory: 'Inventory cannot be empty.',
    negativeInventory: 'Inventory cannot be negative.',
    upperLimit: 'Ensure this value is less than or equal to 32767.',
    monthlyUpperLimit: 'Ensure this value is less than or equal to 6000.',
    monthlyRecurringLowerLimit: (activeReservations) =>
        `Must be greater than or equal to the number of active or upcoming reservations (${activeReservations}).`,
    cancelOrConfirm: 'Confirm or discard changes to continue.',
};

/**
 * A Yup schema that validates inventory values
 * @async
 * @return {(Yup.ValidationError|TInventory[])}
 */
export const inventorySchema = Yup.number()
    // eslint-disable-next-line no-undefined
    .transform((value) => (isNaN(value) ? undefined : value))
    .required(ERROR_MESSAGE_INVENTORY.emptyInventory)
    .typeError(ERROR_MESSAGE_INVENTORY.number)
    .moreThan(-1, ERROR_MESSAGE_INVENTORY.negativeInventory)
    .lessThan(32768, ERROR_MESSAGE_INVENTORY.upperLimit)
    .integer(ERROR_MESSAGE_INVENTORY.number);

/**
 * A Yup schema that validates monthly inventory values
 * @async
 * @return {(Yup.ValidationError|TInventory[])}
 */
export const monthlyInventorySchema = Yup.number()
    // eslint-disable-next-line no-undefined
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError(ERROR_MESSAGE_INVENTORY.number)
    .required(ERROR_MESSAGE_INVENTORY.emptyInventory)
    .moreThan(-1, ERROR_MESSAGE_INVENTORY.negativeInventory)
    .lessThan(6001, ERROR_MESSAGE_INVENTORY.monthlyUpperLimit)
    .integer(ERROR_MESSAGE_INVENTORY.number)
    .when('$type', {
        is: 'recurring',
        then: Yup.number()
            // eslint-disable-next-line no-undefined
            .transform((value) => (isNaN(value) ? undefined : value))
            .test(
                'is-zero-or-more',
                ERROR_MESSAGE_INVENTORY.negativeInventory,
                (value) => value >= 0
            )
            .min(Yup.ref('$activeReservations'), function (value) {
                return ERROR_MESSAGE_INVENTORY.monthlyRecurringLowerLimit(
                    value.min
                );
            }),
    });
